import React from 'react';
import { Link } from 'react-router-dom';
import './Btn.css';

const Btn = (props) => {
    
    const handleMouseEnter = () => {
    if (props.HoverSound) {
        const audio = new Audio(props.HoverSound);
        

        const currentVolume = typeof props.sfxVolume === 'number' ? props.sfxVolume / 100 : 0.7;
        
       
        audio.volume = isFinite(currentVolume) ? currentVolume : 0.7;
        
        audio.play().catch(err => console.log(err));
    }
};

const handleButtonClick = (e) => {
    if (props.ClickSound) {
        const audio = new Audio(props.ClickSound);
        
        const currentVolume = typeof props.sfxVolume === 'number' ? props.sfxVolume / 100 : 0.7;
        audio.volume = isFinite(currentVolume) ? currentVolume : 0.7;
        
        audio.play().catch(err => console.log(err));
    }

    if (props.onClick) {
        props.onClick(e);
    }
};

    const buttonElement = (
        <button 
            className={props.BtnStyle} 
            onClick={handleButtonClick}      
            onMouseEnter={handleMouseEnter}   
        >
            {props.BtnIcon && <img src={props.BtnIcon} alt="" />}
            {props.BtnText}
        </button>
    );

    return props.BtnPath ? (
        <Link to={props.BtnPath}>
            {buttonElement}
        </Link>
    ) : (
        buttonElement
    );
};

export default Btn;